export enum AnimationSettings {
	FADE_DELAY = 400,
}
